import {Component} from '@angular/core';
import {Document} from '../documents/document-countries/document-countries.component';

@Component({
  selector: 'app-electric-scooters-rental-agreement',
  templateUrl: './electric-scooters-rental-agreement.component.html',
})
export class ElectricScootersRentalAgreementComponent {
  countries: Array<Document> = [
    {
      countryName: 'Россия',
      img: 'ru.svg',
      docHref: 'public-offer-electric-scooters-rental-agreement.html'
    },
  ];
}
